import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button, Select, message, Upload } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import BrandCreationSchema from "../../../../Schemas/BrandCreationSchema"

import {
  createBrand,
  updateBrand,
} from "../../../../Services/BrandService";
import { useHistory } from "react-router-dom"; // useHistory for v5


function BrandCreationForm({
  data = {},
  callReFetch,
  isEditMode = false,
  onClose,
}) {
  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      code: data.code|| "",
    },
    enableReinitialize: true,
    validationSchema: BrandCreationSchema,
  });

  const [loading, setLoading] = useState(false);
  const history = useHistory(); // useHistory for v5



  const handleSubmit = async () => {
    const values = formik.values;
    if (
      isEmpty(values.name) ||
      isEmpty(values.code)
    ) {
      message.error("Please insert all required data.");
      return;
    }

    try {
      if (!isEditMode) {
        await createBrand(values);
        message.success("Brand created successfully");
        onClose();
        callReFetch();
        formik.resetForm();
        // Redirect to the brand list or wherever you want
      } else {
        const updatedBrand = await updateBrand(data._id, values);
        callReFetch();
        message.success(
          updatedBrand?.data?.message || "Brand updated successfully"
        );
        onClose(); // Close the modal
      }
    } catch (err) {
      console.error("Error: ", err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    }
  };


  const { values } = formik;
  const titleText = isEditMode ? "Brand Detail" : "Create Brand";
  const submitButtonText = isEditMode ? "Update" : "Create";

  return (
    <div>
      <h2
        className="title"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {titleText}
      </h2>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Nama & Code Tidak boleh duplicate
      </p>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Code hanya di antara 0 - 9
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form
          layout="vertical"
          style={{
            maxWidth: "80vw",
            backgroundColor: "#F5F5F5",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <Form.Item label="Name" required>
            <Input
              style={{ width: "100%" }}
              placeholder="Enter brand name"
              onChange={(e) => formik.setFieldValue("name", e.target.value)}
              value={values.name}
            />
          </Form.Item>
          <Form.Item label="Code" required>
            <Input
              style={{ width: "100%" }}
              placeholder="Enter brand code"
              maxLength={1} // Restrict input length to 1 character
              onChange={(e) => {
                const value = e.target.value;
                if (/^[0-9]?$/.test(value)) {
                  formik.setFieldValue("code", value); // Only allow 0-9 as a string
                }
              }}
              value={values.code}
            />
          </Form.Item>{" "}
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="button"
              className="bg-black"
              onClick={handleSubmit}
              style={{ marginRight: "10px" }}
            >
              {submitButtonText}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

BrandCreationForm.propTypes = {

};

export default BrandCreationForm;
